/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/heading-has-content */
/* eslint-disable no-unused-vars */
import axios from "axios";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import largefavicon from "../../assets/img/optom-large-img.svg";
import logo from "../../assets/img/optopm-logo.svg";
import { Navbar, NavbarBrand, Container } from "reactstrap";
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import he from 'he';

const PrivacyPolicy = () => {
  const [content, setContent] = useState("");

  const getPrivacyPolicy = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}cms-pages/privacy-policy`
      );
      setContent(response.data.cmsPages.content);
    } catch (err) {
      console.log("🚀 ~ getPrivacyPolicy ~ err:", err);
      toast.error("Something went wrong");
    }
  };

  useEffect(() => {
    getPrivacyPolicy();
  }, []);

  return (
    <div className="cms-page-content-wrapper">
      <div className="cms-content-sec">
        <div className="cms-content">
          {/* <h2 className="cms-page-title">Privacy Policy</h2> */}
          <div dangerouslySetInnerHTML={{ __html: he.decode(content) }} />
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
